import { createClient } from '@/shared/api';
import type { MarkInboxMutation, MarkInboxMutationVariables } from '@/shared/api';
import MARK_INBOX_MUTATION from '../mutations/markInbox';

/**
 * Marks an inbox report as reviewed. Runs the markInbox mutation and throws the returned message when it does not report success.
 *
 * @param input - Mutation input identifying the inbox entry and the mark to apply.
 * @returns A promise resolving once the inbox entry has been marked.
 */
const handleMarkInboxReviewed = async (
  input: MarkInboxMutationVariables['input'],
): Promise<void> => {
  const client = createClient();
  const result = await client.mutate<MarkInboxMutation, MarkInboxMutationVariables>({
    mutation: MARK_INBOX_MUTATION,
    variables: {
      input,
    },
  });
  const { data } = result;
  // API always returns this field for a resolved mutation; code already accessed it unconditionally.
  const { markInbox } = data!;
  if (!markInbox!.isSuccess) {
    throw new Error(markInbox!.message ?? undefined);
  }
};

export default handleMarkInboxReviewed;
